"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _helpers = require("../../../content/helpers/helpers");
var _week = require("../../../helpers/week");
var Week = function Week(_ref) {
  var index = _ref.index,
    changeWeek = _ref.changeWeek,
    activeWeek = _ref.activeWeek,
    week = _ref.week;
  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "weeks__week ".concat(activeWeek === index ? 'active' : null),
    onClick: function onClick() {
      return changeWeek(index);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "week-top mb10"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-sm"
  }, !week.weekName ? "".concat((0, _week.getGuestDates)(week).beginDate, " - ").concat((0, _week.getGuestDates)(week).endDate) : week.weekName)), (0, _week.getGuestDates)(week).beginDate && (0, _week.getGuestDates)(week).endDate && /*#__PURE__*/_react["default"].createElement("div", {
    className: "week-bottom"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-xs"
  }, (0, _helpers.numberNth)((0, _week.getGuestDates)(week).beginDate), " - ", (0, _helpers.numberNth)((0, _week.getGuestDates)(week).endDate))));
};
Week.propTypes = {
  index: _propTypes["default"].number.isRequired,
  changeWeek: _propTypes["default"].func.isRequired,
  activeWeek: _propTypes["default"].number,
  week: _propTypes["default"].object
};
var _default = exports["default"] = Week;